import moment from "moment-timezone"
import { useCurrentOrganizationTimeZone } from "./useCurrentOrganizationTimeZone"

export function useLocalTimeToOrgTime(onlyChangeZone = false) {
  const timeZone = useCurrentOrganizationTimeZone()

  return (datetime) => moment(datetime).tz(timeZone, onlyChangeZone)
}
